exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Button_root_1oKmU{display:block;width:100%;border:0;outline:0;padding:10px;background-color:#2778ad;color:#fff;cursor:pointer;-webkit-transition:.2s;transition:.2s}.Button_root_1oKmU:hover{background-color:#186091}.Button_bordered_1fiLg{background-color:#fff;border:1px solid #2778ad;color:#2778ad;padding:10px;margin:10px 0}.Button_bordered_1fiLg:hover{background-color:#fff;border-color:#186091}", ""]);

// exports
exports.locals = {
	"root": "Button_root_1oKmU",
	"bordered": "Button_bordered_1fiLg"
};